import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store/store.js'
// import BASEURL from '@/utils/ipConfig'
// import {tryHideFullScreenLoading} from './axiosHelperLoading'
import { showFullScreenLoading, tryHideFullScreenLoading } from './axiosHelperLoading'
import loadingApi from '@/utils/loadingApi.js'
// create an axios instance
// axios.defaults.withCredentials = true
const service = axios.create({
  baseURL: process.env.API_PAGE,
  // baseURL: 'http://192.168.31.151:2005',
  // baseURL: 'http://192.168.0.118:2005',
  // baseURL: 'http://124.71.32.183:2005',
  withCredentials: true,
  timeout: 500000000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  if (!loadingApi.api.includes(config.url) && config.url != '/resource/queryUserSendMessage') {
    showFullScreenLoading()
  }
  // showFullScreenLoading()

  const token = store.getters.token
  if (token) {
    config.headers['Authorization'] = token // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    tryHideFullScreenLoading()
    if (!_selectIsHide(loadingApi.api, response.config.url)) {
      tryHideFullScreenLoading()
    }

    if (response.data.code === '000000') {
      return response.data.data
    } else {
      // Message.closeAll()
      Message({
        message: response.data.msg,
        dangerouslyUseHTMLString: true,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(response.data.msg)
    }
  },
  /**
  * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
  * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
  */
  // const res = response.data;
  //    if (res.code !== 20000) {
  //      Message({
  //        message: res.message,
  //        type: 'error',
  //        duration: 5 * 1000
  //      });
  //      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //          confirmButtonText: '重新登录',
  //          cancelButtonText: '取消',
  //          type: 'warning'
  //        }).then(() => {
  //          store.dispatch('FedLogOut').then(() => {
  //            location.reload();// 为了重新实例化vue-router对象 避免bug
  //          });
  //        })
  //      }
  //      return Promise.reject('error');
  //    } else {
  //      return response.data;
  //    }
  error => {
    if (!loadingApi.api.includes(error.response.data.path)) {
      tryHideFullScreenLoading()
    }
    // tryHideFullScreenLoading()
    // token失效 或 同一账号 他人登录后，强制退出
    if (error.response.status === 401) {
      // 通过开关进行控制，多次弹出的情况
      if (store.state.isShowErrorMessageBox) {
        MessageBox.alert('您已被登出，是否重新登录', '重新登录', {
          confirmButtonText: '重新登录',
          showClose: false,
          type: 'warning'
        }).then(() => {
          store.dispatch('LogOut').then(() => {
            // location.reload();// 为了重新实例化vue-router对象 避免bug
            store.commit('SET_isShowErrorMessageBox', true)
          })
        })
        store.commit('SET_isShowErrorMessageBox', false)
      }
      return Promise.reject(error)
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  }
)

// 判断 返回后，接口地址是否在黑名单目录里
function _selectIsHide (arr, url) {
  let flag = false
  for (let item of arr) {
    if (url.includes(item)) {
      flag = true
      break
    }
  }
  return flag
}

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js